/* InfoLabelWithToolTip.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["aria-expanded"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _21 = "._jf4cnqa1:hover{-webkit-text-decoration-style:solid;text-decoration-style:solid}";
const _20 = "._1bnx8stv:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}";
const _19 = "._9oik18uv:hover{-webkit-text-decoration-color:initial;text-decoration-color:initial}";
const _18 = "._t4pt1hna>span{overflow-wrap:break-word}";
const _17 = "._y3gn1e5h{text-align:left}";
const _16 = "._1e0c1o8l{display:inline-block}";
const _15 = "._4cvr1h6o{align-items:center}";
const _14 = "._1e0c1txw{display:flex}";
const _13 = "._vwz41k92{line-height:1.25rem}";
const _12 = "._k48pni7l{font-weight:600}";
const _11 = "._1wyb1j6v{font-size:1rem}";
const _10 = "._syaz1jij{color:var(--ds-text-subtlest)}";
const _9 = "._o5721q9c{white-space:nowrap}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import { Popup } from '@atlaskit/popup';
import { Box, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import { BodySmall } from '@atlassian/mpac-primitives';
import React, { useState } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _8 = "._13t31q5e span{line-height:1.5em}";
const _7 = "._1xjx1q5e span{height:1.5em}";
const _6 = "._e2oo1q5e span{width:1.5em}";
const _5 = "._1e0c1nu9{display:inline}";
const _4 = "._18u0idpf{margin-left:0}";
const _3 = "._otyridpf{margin-bottom:0}";
const _2 = "._2hwxidpf{margin-right:0}";
const _ = "._19pkidpf{margin-top:0}";
const IconWrapper = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "figure",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1nu9 _e2oo1q5e _1xjx1q5e _13t31q5e", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  IconWrapper.displayName = 'IconWrapper';
}
const LastWordWithIcon = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_o5721q9c", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  LastWordWithIcon.displayName = 'LastWordWithIcon';
}
const InfoLabelContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_10, _11, _12, _13, _14, _15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_syaz1jij _1wyb1j6v _k48pni7l _vwz41k92 _1e0c1txw _4cvr1h6o", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoLabelContainer.displayName = 'InfoLabelContainer';
}
const InfoLabel = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "span",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_16, _17, _18, _19, _20, _21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1o8l _y3gn1e5h _t4pt1hna _9oik18uv _1bnx8stv _jf4cnqa1", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  InfoLabel.displayName = 'InfoLabel';
}
const contentStyles = xcss({
  maxWidth: '320px',
  paddingInline: 'space.300',
  paddingBlock: 'space.200'
});
const buttonStyles = xcss({
  padding: 'space.0',
  background: 'none',
  alignSelf: 'flex-start',
  width: 'fit-content',
  maxWidth: '100%',
  display: 'flex',
  alignItems: 'center'
});
const TooltipContent = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TooltipContent.displayName = 'TooltipContent';
}
export const InfoLabelWithToolTip = props => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClicked, setIsClick] = useState(false);
  const words = props.text.split(' ');
  const lastWord = words.pop();
  const handleClick = () => {
    setIsClick(true);
    setIsOpen(true);
  };
  const handleMouseEnter = () => {
    setIsOpen(true);
  };
  const handleMouseLeave = () => {
    if (isClicked) return;
    setIsOpen(false);
  };
  const handleClose = () => {
    setIsClick(false);
    setIsOpen(false);
  };
  const handleFocus = () => {
    setIsOpen(true);
  };
  const handleBlur = () => {
    setIsOpen(false);
  };
  return /*#__PURE__*/_jsx(Popup, {
    isOpen: isOpen,
    onClose: handleClose,
    autoFocus: false,
    placement: "bottom-start",
    shouldRenderToParent: true,
    shouldDisableFocusLock: true,
    content: () => /*#__PURE__*/_jsx(Box, {
      xcss: contentStyles,
      children: /*#__PURE__*/_jsx(TooltipContent, {
        id: "tooltip-content",
        children: props.content[0].text
      })
    }),
    trigger: triggerProps => {
      const {
          'aria-expanded': ariaExpanded
        } = triggerProps,
        restTriggerProps = _objectWithoutProperties(triggerProps, _excluded6);
      return (
        /*#__PURE__*/
        _jsx(Pressable, _objectSpread(_objectSpread({}, restTriggerProps), {}, {
          xcss: [buttonStyles],
          onMouseEnter: handleMouseEnter,
          onMouseLeave: handleMouseLeave,
          onClick: handleClick,
          onFocus: handleFocus,
          onBlur: handleBlur,
          "aria-describedby": isOpen ? 'tooltip-content' : undefined,
          children: /*#__PURE__*/_jsx(InfoLabelContainer, {
            children: /*#__PURE__*/_jsxs(InfoLabel, {
              children: [/*#__PURE__*/_jsx("span", {
                children: words.join(' ')
              }), /*#__PURE__*/_jsxs(LastWordWithIcon, {
                children: [' ', lastWord, /*#__PURE__*/_jsx(IconWrapper, {
                  children: /*#__PURE__*/_jsx(EditorPanelIcon, {
                    label: "information",
                    primaryColor: "var(--ds-text-subtlest)"
                  })
                })]
              })]
            })
          })
        }))
      );
    }
  });
};